import { StoreItemModel } from './store-item-model';
import { Serializable } from '../../../core/models/serializable';
import { CvDatabaseAccessTokenStatus } from '@admin/product-purchases/shared/models/cv-database-access-token-status';

export class CvDatabaseAccessTokenModel
  implements Serializable<CvDatabaseAccessTokenModel>
{
  fromObject(obj: any): CvDatabaseAccessTokenModel {
    Object.assign(this, obj);

    if (obj.storeItem != null) {
      let s = new StoreItemModel();

      this.storeItem = s.fromObject(obj.storeItem);
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public cvDatabaseAccessTokenId: number;
  public cvDatabaseAccessTokenRequestId: number;
  public customerId: number;
  // public List<int> CvDatabaseProviderIds { get; set; }
  public viewCount: number;
  public status: CvDatabaseAccessTokenStatus;

  public dayCount: number; //TODO add to db

  public demoViewCountLimit: number;
  public totalViewCountLimit: number;

  public approveDate: Date;
  public expireDate: Date;
  public terminationDate: Date;
  public createDate: Date;

  public approveUserId: number;
  public rejectUserId: number;
  public terminateUserId: number;

  public storeItemId: number;

  public storeItem: StoreItemModel;
}
